import React from 'react';
import { Box, Typography, MenuItem, Select, FormControl, InputLabel, SvgIcon, Divider } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight, FirstPage, LastPage } from '@mui/icons-material';
import { FooterPagintionStyles, MenuItemOptionStyles } from './Style';
import { AutoComplete, IconButton, IconButton2 } from 'components/Form';
import { OptionStyles } from 'components/Form/Styled';
import { ReactComponent as PulldownIcon } from 'assets/icons/Pulldown.svg';
import { SelectStyles } from './Style'
import { useSelector } from 'react-redux';

const CustomPagination = ({
    count,
    page,
    pageSize,
    onPageChange,
    loading,
    onPageSizeChange,
    rowsPerPageOptions = [15, 25, 35, 50, 1000]
}) => {
    const totalPages = Math.ceil(count / pageSize);
    const from = page * pageSize + 1;
    const to = Math.min((page + 1) * pageSize, count);

    const { brokenDisplay } = useSelector(state => state.general)

    return (
        <FooterPagintionStyles>
            {loading ||
                <React.Fragment>
                    <div className='select-rows-number'>
                        <div className='rows-number'>{"מספר רשומות לעמוד"}</div>
                        <Select
                            value={pageSize}
                            onChange={(e) => {
                                onPageSizeChange(Number(e.target.value))
                            }}
                            sx={{
                                '& .MuiSelect-icon': {
                                    pointerEvents: 'none', // חשוב מאוד כדי שהלחיצה תעבוד
                                }
                            }}

                            IconComponent={(props) => (
                                <SvgIcon
                                    {...props}
                                    component={PulldownIcon}
                                    inheritViewBox
                                    sx={{ fontSize: 10, pointerEvents: 'none' }}
                                />
                            )}
                            size="small"
                            color={"thirdly"}
                            variant="outlined"
                        >
                            {rowsPerPageOptions.map((opt) => (
                                <MenuItemOptionStyles
                                    component={OptionStyles}
                                    key={opt}
                                    value={opt}
                                    selected={opt === pageSize}
                                >
                                    {opt}
                                </MenuItemOptionStyles>
                            ))}
                        </Select>
                    </div>

                    {/* כפתורי ניווט */}
                    <div className='move-between-pages'>
                        <div className={`current-page-rows ${brokenDisplay && 'blurred2'}`} variant="body2">
                            {`${from}-${to} מתוך ${count}`}
                        </div>
                        <IconButton2
                            size="small"
                            variant="solid"
                            disabled={page === 0}
                            onClick={() => onPageChange(page - 1)}
                        >
                            <i class="fa-regular fa-chevron-right"></i>
                        </IconButton2>
                        <IconButton2
                            size="small"
                            variant="solid"
                            disabled={page >= totalPages - 1}
                            onClick={() => onPageChange(page + 1)}
                        >
                            <i class="fa-regular fa-chevron-left"></i>
                        </IconButton2>
                    </div>
                </React.Fragment>
            }
        </FooterPagintionStyles>
    );
};

export default CustomPagination